export const nightBlue = '#172957';
export const blue = '#07C0C6';
export const emerald = '#86DC84';
export const orange = '#FF5B35';
export const darkOrange = '#E55126';
export const lightOrange = '#FFEEEA';
export const redOrange = '#FF9B93';
export const yellow = '#FFCC00';
export const darkGrey = '#202426';
export const midGrey = '#262729';
export const grey = '#8C8C8C';
export const lightGrey = '#C4C4C4';
export const lighterGrey = '#F7F9F9';
export const greyBlue = '#7C84A4';
export const lightGreyBlue = '#F0F1F8';
export const black = '#262729';
export const white = '#FFFFFF';
export const alertError = '#FF9B93';
export const alertSuccess = '#86DC84';

export default {
  nightBlue,
  blue,
  emerald,
  orange,
  darkOrange,
  lightOrange,
  redOrange,
  yellow,
  darkGrey,
  midGrey,
  grey,
  lightGrey,
  lighterGrey,
  greyBlue,
  lightGreyBlue,
  black,
  white,
  alertError,
  alertSuccess,
};
